export default {
  auto: ['actions'],
  store: {
    state: {
      downloadCounter: 0,
    },
    actions: {
      DOWNLOAD({ commit, state }, url) {
        const iframe = document.createElement('iframe')
        iframe.id = `downloader-${state.downloadCounter}`
        iframe.style.display = 'none'
        document.body.append(iframe)
        iframe.src = url
        commit('INC_DOWNLOAD_COUNTER')
      },
      async DOWNLOAD_FILE({ dispatch }, { id, fileId }) {
        dispatch('DOWNLOAD', (await dispatch('GET_FILE_DOWNLOAD', fileId || id)).url)
      },
    },
    mutations: {
      INC_DOWNLOAD_COUNTER(state) {
        state.downloadCounter += 1
      },
    },
  },
}
